// App logo — SSDC circular blue mark (public/logo.png). The image already
// carries its own blue circle, so render it directly (no coloured wrapper box).
export default function BrandMark({ size = 20, className = '' }) {
  return (
    <img
      src="/logo.png"
      alt="Smile Seasons"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={`object-contain flex-none ${className}`}
    />
  )
}
